.funnel-card {
    background-color: var(--white);
    height: 104px;
    padding: 12px 12px 4px 12px;
}

.funnel-card:not(:last-child) {
    border-bottom: 1px solid var(--grey-xlt);
}

.funnel-bar {
    background-color: var(--off-white);
    border: 1px solid var(--off-white-dk);
    border-radius: 3px;
    padding: 4px 0 4px 0;
}

.funnel-bar--hoverable:hover {
    cursor: pointer;
    background-color: var(--off-white-dk);
}

.funnel-delta {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--green-bg);
    border: 2px solid var(--green-lt);
    border-bottom-width: 0;
    bottom: 0;
    padding: 4px;
    position: relative;
    min-height: 22px;
    width: 164px;
}

/* Trapezoid chevron effect - left side */
.funnel-delta::before {
    content: '';
    position: absolute;
    bottom: -3px;
    left: 0;
    height: 10px;
    width: 50%;
    background-color: var(--green-bg);
    border-bottom: 2px solid var(--green-lt);
    transform: skewY(4deg);
    z-index: 1;
}

/* Trapezoid chevron effect - right side */
.funnel-delta::after {
    content: '';
    position: absolute;
    bottom: -3px;
    right: 0;
    height: 10px;
    width: 50%;
    background-color: var(--green-bg);
    border-bottom: 2px solid var(--green-lt);
    transform: skewY(-4deg);
    z-index: 1;
}

.funnel-chart-wrapper {
    position: relative;
    width: 100%;
}

.funnel-empty-state-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding-top: 64px;
    z-index: 10;
}

.funnel-empty-state-overlay::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: var(--white);
    opacity: 0.7;
}

.funnel-empty-state-content {
    position: relative;
    background-color: var(--white);
    border: 1px solid var(--grey-xlt);
    border-radius: 4px;
    padding: 48px;
    max-width: 400px;
}
